module.exports = __webpack_public_path__ + "static/maps-a20b0a5d57e13452d1ee837ee9547c2b.jpg";